import { Component, Input, OnInit } from '@angular/core';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-item-needs-improvement',
  templateUrl: './item-needs-improvement.component.html',
  styleUrls: ['./item-needs-improvement.component.scss']
})
export class ItemNeedsImprovementComponent {

  @Input()
  public item: InventoryItem;

  constructor(
    private inventoryService: InventoryService) {}

  markImprovementDone() {
    this.item.improvementRequest = "";
      
    this.item.log.push({
      text: "Improved",
      date: new Date
    })

    this.save();
  }


  save() {
    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe();
  }
}
